import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Application root.
 *
 * Header, bottom bar and the toast host are NOT here -- `MainLayoutComponent`
 * (`src/app/layout/main-layout/main-layout.ts`) owns them, mounted at
 * `app.routes.ts`'s single top-level route so the shell is not re-created on
 * navigation. This component owns only what is genuinely global: the skip link,
 * which is needed before any route has rendered its own `<main>`.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
